// src/components/hero/Hero.jsx
import React from "react";
import { Link } from "react-router-dom";

import homebuilding1 from "../../images/homebuilding1.jpeg";
import homebuilding2 from "../../images/homebuilding2.jpeg";
import services1 from "../../images/services1.jpeg";
import services2 from "../../images/services2.jpeg";
import services3 from "../../images/services3.jpeg";
import services4 from "../../images/services4.jpeg";

const Hero = () => {
  const phoneDisplay = "703-662-3685";
  const phoneDial = phoneDisplay.replace(/[^0-9]/g, "");

  const proposalsEmail = "support@jmccontractinggroup.com";
  const subject = encodeURIComponent("Proposal Request");
  const body = encodeURIComponent(
    "Hi JMC Contracting Group,\n\nI’d like to request a proposal/estimate.\n\nProject Location:\nType of Work:\nDesired Start Date:\nBest Contact Name/Phone:\n\nAdditional Details:\n"
  );
  const mailtoHref = `mailto:${proposalsEmail}?subject=${subject}&body=${body}`;

  return (
    <>
      <div id="scrool"></div>

      <div className="home-wrapper">
        <div className="jmc-flyer">
          {/* Top photo strip */}
          <div className="jmc-strip">
            <img src={services3} alt="JMC work 1" />
            <img src={homebuilding1} alt="JMC work 2" />
            <img src={services4} alt="JMC work 3" />
          </div>

          {/* Navy title band */}
          <div className="jmc-title-band">
            <h1>
              JMC Contracting Group LLC
              <span>Janitorial • Maintenance • Construction</span>
            </h1>
          </div>

          {/* Short sub line */}
          <div className="jmc-band-sub">
            Commercial and residential services built around quality workmanship,
            responsive scheduling, and clear communication.
          </div>

          {/* Flyer body */}
          <div className="jmc-body">
            <div className="jmc-body-grid">
              {/* LEFT: paragraphs only */}
              <div className="jmc-list">
                <h2>Built for Property Work That Has to Be Done Right</h2>

                <p>
                  JMC Contracting Group LLC is a licensed, insured contractor serving
                  commercial facilities, community associations, and residential
                  clients with dependable crews and a practical, results-first approach.
                  From routine maintenance and janitorial service to repairs, rebuilds,
                  and improvements—our goal is simple: do the work the right way, keep
                  the site clean, and keep you informed.
                </p>

                <p>
                  We support projects that range from fast turnaround repairs to larger
                  scopes that require planning, coordination, and professional execution.
                  When timelines matter and budgets need to stay controlled, we provide
                  straightforward communication and documentation so decisions stay easy
                  and the work stays on track.
                </p>

                <p>
                  Licensing &amp; coverage are a priority for us. We operate as{" "}
                  <strong>Virginia Class A Commercial Builders</strong> and{" "}
                  <strong>Virginia Class A Residential Builders</strong>, and we are
                  licensed in Maryland as a{" "}
                  <strong>Maryland MHIC contractor</strong> and{" "}
                  <strong>Maryland Residential Home Builder</strong>. We are also
                  registered as <strong>West Virginia Home Builders</strong>.
                </p>

                <div
                  style={{
                    marginTop: 18,
                    display: "flex",
                    gap: 12,
                    flexWrap: "wrap",
                  }}
                >
                  <Link className="service-btn" to="/service">
                    View Services
                  </Link>

                  {/* Email Proposals button (replaces /proposal route) */}
                  <a className="service-btn" href={mailtoHref}>
                    Email Proposals
                  </a>

                </div>

                <div className="jmc-note">
                  Commercial • Residential • HOA / Condo Communities
                </div>
              </div>

              {/* RIGHT: stacked images */}
              <div className="jmc-img-stack">
                <img src={services2} alt="JMC stacked 1" />
                <img src={homebuilding2} alt="JMC stacked 2" />
                <img src={services1} alt="JMC stacked 3" />
              </div>
            </div>

            {/* CTA bands */}
            <div className="jmc-cta-band">
              <h2>Call For A Free Estimate!</h2>
            </div>

            <div className="jmc-phone-band">
              <a href={`tel:${phoneDial}`}>{phoneDisplay}</a>
            </div>

            <div className="jmc-note">
              Fast scheduling • Clear scopes • Quality workmanship • Clean job sites
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Hero;